import LibranzasResumen from '@/components/molecules/libranzas/libranzasResumen/libranzasResumen';
import LibranzasContactForm from '@/components/molecules/libranzas/libranzasContactForm/libranzasContactForm';
import LibranzasAccionesPago from '@/components/molecules/libranzas/libranzasAccionesPago/libranzasAccionesPago';
import type { PaymentHeadInfo, PaymentStep } from '@/components/molecules/libranzas/libranzasAccionesPago/libranzasAccionesPago';
import './libranzasResumenPago.scss';

interface LibranzasResumenPagoProps {
    documentoEmpresa: string;
    nombreEmpresa: string;
    total: number;
    email: string;
    onEmailChange: (value: string) => void;
    celular: string;
    onCelularChange: (value: string) => void;
    termsAccepted: boolean;
    onTermsToggle: () => void;
    onBack: () => void;
    onCancel?: () => void;
    onGoToConfirmacion: () => void;
    pagarDisabled: boolean;
    title?: string;
    paymentMethodRefs?: PaymentStep[];
    paymentHeadInfo?: PaymentHeadInfo;
}

const LibranzasResumenPago = ({
    documentoEmpresa,
    nombreEmpresa,
    total,
    email,
    onEmailChange,
    celular,
    onCelularChange,
    termsAccepted,
    onTermsToggle,
    onBack,
    onCancel,
    onGoToConfirmacion,
    pagarDisabled,
    title,
    paymentMethodRefs,
    paymentHeadInfo,
}: LibranzasResumenPagoProps) => {

    return (
        <div className="o-payment">
            {title && <h2 className="o-payment__title">{title}</h2>}
            <div className="o-libranzas-resumen-pago">
                <div className="o-libranzas-resumen-pago__col-left">
                    <LibranzasResumen
                        documentoEmpresa={documentoEmpresa}
                        nombreEmpresa={nombreEmpresa}
                        total={total}
                    />
                </div>
                <div className="o-libranzas-resumen-pago__col-right">
                    <LibranzasContactForm
                        email={email}
                        onEmailChange={onEmailChange}
                        celular={celular}
                        onCelularChange={onCelularChange}
                    />
                    <LibranzasAccionesPago
                        termsAccepted={termsAccepted}
                        onTermsToggle={onTermsToggle}
                        onBack={onBack}
                        onCancel={onCancel}
                        onGoToConfirmacion={onGoToConfirmacion}
                        pagarDisabled={pagarDisabled}
                        paymentHeadInfo={paymentHeadInfo}
                        paymentMethodRefs={paymentMethodRefs}
                    />
                </div>
            </div>
        </div>
    );
};

export default LibranzasResumenPago;
